import styled from 'styled-components';
import { StyledLink } from '../../../common/components/Link.styles';
import { Row, Col } from '../../../common/components/layout/FlexLayout';
import { Breakpoint, FontSize } from '../../../common/styles/constants';

export const PopularSearchLink = styled(StyledLink)`
  font-size: ${FontSize.SMALL};
  margin-bottom: 8px;
  padding: 12px 0;

  ${Breakpoint.MEDIUM} {
    padding: initial;
  }
`;

export const PopularSearchRow = styled(Row)`
  flex-flow: wrap;
  justify-content: flex-start;

  ${Breakpoint.MEDIUM} {
    justify-content: space-between;
  }

  ${Col} {
    flex: calc(50% - 20px);
    justify-content: flex-start;
    margin-bottom: 24px;

    ${Breakpoint.MEDIUM} {
      flex: calc(50% - 20px);
    }

    ${Breakpoint.EXTRA_LARGE} {
      flex: 1;
      max-width: fit-content;
    }
  }
`;
